// extracted by mini-css-extract-plugin
export default {"imagebox":"home_imagebox__dhy5x","textfont":"home_textfont__z6WDL","brandbox":"home_brandbox__XikQv","homebtn":"home_homebtn__cUcrN"};